/* ==========================================================================
   BUNDLE OFFER — Web Component (Black Hype) - B1G1 COM TELETRANSPORTE
   ========================================================================== */

(function () {
  if (window.customElements.get('bundle-offer')) return;

  class BundleOffer extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      this.formId = this.dataset.formId;
      this.productId = this.dataset.productId;
      this.discountPct = 50;
      this.bundleType = 'b1g2';
      this.itemsTotal = 2;
      this.itemsPaid = 1;

      this.selectedSecondVariantId = null;
      this.selectedSecondProperties = null;
      this.selectedSecondTitle = '';
      this.selectedSecondVariantTitle = '';
      this.selectedSecondOptionsText = '';
      this.selectedSecondImage = '';
      this.selectedSecondPrice = 0;

      this.pickingItemSlot = 2;
      this.selectedMode = 'bundle';
      this.currentWizardStep = null;

      // 1. Reloca fisicamente o Bundle para dentro do formulário do produto
      this.relocateToProductForm();
      
      // 2. Puxa os seletores de tamanho originais para dentro do Step 1
      this.moveControlsToSlot();

      this.setupWizard();
      this.setupDetails();
      
      // 3. Intercepta o clique do botão "Add to Cart" original do tema
      this.setupFormIntercept();
      
      this.setupCarousels();
      this.restoreSelection();
      
      this.syncWizardVisibility();
      
      // 4. Esconde apenas botões de checkout dinâmico (Buy it Now / Shop Pay)
      this.updatePaymentButtonVisibility();
    }

    syncWizardVisibility() {
      const isComplete = !!this.selectedSecondVariantId;
      if (isComplete) {
        this.showWizardStep('summary');
      } else {
        this.pickingItemSlot = 2;
        this.showWizardStep('first');
      }
    }

    setupWizard() {
      this.querySelectorAll('[data-wizard-goto]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const target = btn.dataset.wizardGoto;
          if (this.currentWizardStep === 'summary' && target === 'first') {
            this.pickingItemSlot = 2;
            this.resetDetailStep();
          }
          this.showWizardStep(target);
        });
      });

      this.querySelectorAll('.bundle-picker__item').forEach((item) => {
        item.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const id = item.dataset.productId;
          this.openDetail(id);
        });
      });
    }

    showWizardStep(step) {
      const steps = this.querySelectorAll('[data-wizard-step]');
      steps.forEach((el) => {
        el.hidden = el.dataset.wizardStep !== step;
      });
      this.currentWizardStep = step;

      this.updateWizardCopyForSlot(step);

      if (step === 'grid') {
        setTimeout(() => this.updateAllCarouselsVisibility(), 50); 
      }

      if (step === 'detail') {
        const detailStep = this.querySelector('[data-wizard-step="detail"]');
        if (detailStep) detailStep.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
      if (step === 'summary') this.updateSummaryUI();
    }

    updateWizardCopyForSlot(step) {
      const progressEl = this.querySelector('[data-wizard-progress]');
      const gridTitleEl = this.querySelector('[data-wizard-grid-title]');
      const detailTitleEl = this.querySelector('[data-wizard-detail-title]');

      if (step === 'first') {
        if (progressEl) progressEl.textContent = `Step 1 of 3: Your Item`;
      } else if (step === 'grid') {
        if (progressEl) progressEl.textContent = `Step 2 of 3: Free Item`;
        if (gridTitleEl) gridTitleEl.textContent = `Choose your FREE product`;
      } else if (step === 'detail') {
        if (progressEl) progressEl.textContent = `Step 3 of 3: Customize`;
        if (detailTitleEl) detailTitleEl.textContent = `Customize your FREE item`;
      }
    }

    openDetail(productId) {
      this.querySelectorAll('[data-detail-for]').forEach((d) => {
        d.hidden = d.dataset.detailFor !== String(productId);
      });
      this.showWizardStep('detail');
    }

    setupDetails() {
      this.querySelectorAll('[data-detail-for]').forEach((detailEl) => this.setupDetail(detailEl));

      const confirmBtns = this.querySelectorAll('[data-detail-confirm]');
      confirmBtns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const detailEl = this.querySelector('[data-detail-for]:not([hidden])');
          if (detailEl) this.confirmDetail(detailEl);
        });
      });
    }

    setupDetail(detailEl) {
      let variants = [];
      try {
        const script = detailEl.querySelector('[data-detail-variants]');
        variants = script ? JSON.parse(script.textContent) : [];
      } catch (e) { variants = []; }
      detailEl._variants = variants;

      const defaultVariant = variants.find((v) => v.available) || variants[0];
      detailEl._selectedVariant = defaultVariant;

      detailEl.querySelectorAll('[data-option-input]').forEach((input) => {
        input.addEventListener('change', () => this.onOptionChange(detailEl));
      });

      this.onOptionChange(detailEl);
    }

    onOptionChange(detailEl) {
      const optionEls = detailEl.querySelectorAll('.bundle-picker__detail-option');
      const selectedValues = [];
      optionEls.forEach((optEl) => {
        const checked = optEl.querySelector('input[data-option-input]:checked');
        const val = checked ? checked.value : null;
        selectedValues.push(val);
        const label = optEl.querySelector('[data-option-selected]');
        if (label && val) label.textContent = val;
        optEl.querySelectorAll('.bundle-picker__detail-option-value').forEach((el) => {
          const input = el.querySelector('input');
          el.classList.toggle('is-selected', input && input.checked);
        });
      });

      const match = detailEl._variants.find((v) =>
        selectedValues.every((val, i) => val == null || v.options[i] === val)
      );
      if (match) {
        detailEl._selectedVariant = match;
        const priceEl = detailEl.querySelector('[data-detail-price]');
        if (priceEl) priceEl.textContent = this.formatMoney(match.price);
      }
      this.updateCustomizeVisibility(detailEl);
    }

    updateCustomizeVisibility(detailEl) {
      const customizeBox = detailEl.querySelector('[data-detail-customize]');
      if (!customizeBox) return;
      const variant = detailEl._selectedVariant;
      if (!variant) { customizeBox.hidden = true; return; }
      const optionNames = ['option1', 'option2', 'option3'];
      const matched = optionNames.some((key) => {
        const val = variant[key];
        return val && /customize/i.test(val) && !/not\s*customize/i.test(val);
      });
      customizeBox.hidden = !matched;
    }

    confirmDetail(detailEl) {
      const variant = detailEl._selectedVariant;
      if (!variant || !variant.available) {
        alert('This variant is unavailable. Please choose another option.');
        return;
      }

      const title = detailEl.querySelector('.bundle-picker__detail-title')?.textContent.trim() || '';
      const image = detailEl.querySelector('.bundle-picker__detail-image')?.src || '';

      const optionLabels = [];
      detailEl.querySelectorAll('.bundle-picker__detail-option').forEach((optEl) => {
        const name = optEl.dataset.optionName;
        const val = optEl.querySelector('[data-option-selected]')?.textContent?.trim();
        if (name && val) optionLabels.push(`${name}: ${val}`);
      });
      const optionsText = optionLabels.join(' • ');

      const props = {};
      const customizeBox = detailEl.querySelector('[data-detail-customize]');
      if (customizeBox && !customizeBox.hidden) {
        detailEl.querySelectorAll('[data-detail-prop]').forEach((input) => {
          const key = input.dataset.detailProp;
          const val = input.value.trim();
          if (val) props[key] = val;
        });
      }
      const properties = Object.keys(props).length ? props : null;

      this.selectedSecondVariantId = variant.id;
      this.selectedSecondVariantTitle = variant.title || '';
      this.selectedSecondTitle = title;
      this.selectedSecondImage = image;
      this.selectedSecondOptionsText = optionsText;
      this.selectedSecondProperties = properties;
      this.selectedSecondPrice = parseInt(variant.price) || 0;
      
      this.persistSelection();
      this.showWizardStep('summary');
    }

    resetDetailStep() {
      this.querySelectorAll('[data-detail-for]').forEach((d) => { d.hidden = true; });
      this.querySelectorAll('[data-detail-prop]').forEach((input) => {
        input.value = '';
      });
      this.querySelectorAll('[data-name-count]').forEach((el) => { el.textContent = '0/12'; });
    }

    updateSummaryUI() {
      const firstDetails = this.buildFirstItemDetailsText();
      const firstDetailsEl = this.querySelector('[data-summary-first-details]');
      if (firstDetailsEl) firstDetailsEl.textContent = firstDetails;

      const secondImg = this.querySelector('[data-summary-second-image]');
      const secondTitle = this.querySelector('[data-summary-second-title]');
      const secondDetails = this.querySelector('[data-summary-second-details]');
      if (secondImg && this.selectedSecondImage) {
        secondImg.src = this.selectedSecondImage;
        secondImg.alt = this.selectedSecondTitle;
      }
      if (secondTitle) secondTitle.textContent = this.selectedSecondTitle;
      if (secondDetails) secondDetails.textContent = this.buildItemDetailsText('second');
    }

    buildFirstItemDetailsText() {
      const target = this.querySelector(`[data-embedded-controls][data-slot="bundle-first"]`);
      const picker = target ? target.querySelector('variant-radios') : document.querySelector('variant-radios');
      const parts = [];
      
      if (picker) {
        picker.querySelectorAll('fieldset').forEach((fs) => {
          const legend = fs.querySelector('legend');
          const checked = fs.querySelector('input[type="radio"]:checked');
          if (legend && checked) {
            const optName = legend.textContent.trim().replace(/:$/, '');
            const optVal = checked.value;
            parts.push(`${optName}: ${optVal}`);
          }
        });
      }
      return parts.join(' • ');
    }

    buildItemDetailsText(slot) {
      const optionsText = this.selectedSecondOptionsText;
      const variantTitle = this.selectedSecondVariantTitle;
      const properties = this.selectedSecondProperties;

      const parts = [];
      if (optionsText) {
        parts.push(optionsText);
      } else if (variantTitle && variantTitle !== 'Default Title') {
        parts.push(variantTitle);
      }
      if (properties) {
        Object.entries(properties).forEach(([k, v]) => {
          if (v) parts.push(`${k}: ${v}`);
        });
      }
      return parts.join(' • ');
    }

    persistSelection() {
      sessionStorage.setItem(
        `bundle-${this.productId}`,
        JSON.stringify({
          second: {
            variantId: this.selectedSecondVariantId,
            title: this.selectedSecondTitle,
            variantTitle: this.selectedSecondVariantTitle,
            optionsText: this.selectedSecondOptionsText,
            image: this.selectedSecondImage,
            properties: this.selectedSecondProperties,
            price: this.selectedSecondPrice,
          }
        })
      );
    }

    restoreSelection() {
      try {
        const saved = sessionStorage.getItem(`bundle-${this.productId}`);
        if (!saved) return;
        const data = JSON.parse(saved);
        if (!data) return;

        const variantExists = (variantId) => {
          if (!variantId) return false;
          let found = false;
          this.querySelectorAll('[data-detail-for]').forEach((detailEl) => {
            try {
              const script = detailEl.querySelector('[data-detail-variants]');
              const variants = script ? JSON.parse(script.textContent) : [];
              if (variants.some((v) => String(v.id) === String(variantId))) found = true;
            } catch (e) {}
          });
          return found;
        };

        const sec = data.second || {};
        if (variantExists(sec.variantId)) {
          this.selectedSecondVariantId = sec.variantId;
          this.selectedSecondTitle = sec.title || '';
          this.selectedSecondVariantTitle = sec.variantTitle || '';
          this.selectedSecondOptionsText = sec.optionsText || '';
          this.selectedSecondImage = sec.image || '';
          this.selectedSecondProperties = sec.properties || null;
          this.selectedSecondPrice = sec.price || 0;
        }

        if (!this.selectedSecondVariantId) {
          sessionStorage.removeItem(`bundle-${this.productId}`);
        }
      } catch (e) {
        sessionStorage.removeItem(`bundle-${this.productId}`);
      }
    }

    // ====== FUNÇÕES DE TELETRANSPORTE ======
    relocateToProductForm() {
      const form = this.getForm();
      if (!form) return;
      const buttonsContainer = form.querySelector('.product-form__buttons');
      if (!buttonsContainer) return;

      // Move a tag <bundle-offer> inteira para antes dos botões originais
      const originalWrapper = this.closest('.bundle-offer-section-wrapper');
      form.insertBefore(this, buttonsContainer);
      if (originalWrapper) originalWrapper.style.display = 'none';
    }

    moveControlsToSlot() {
      const target = this.querySelector(`[data-embedded-controls][data-slot="bundle-first"]`);
      if (!target) return;

      // Puxa o seletor de variante da página para dentro do Step 1
      const variantPicker = document.querySelector('variant-radios');
      if (variantPicker && variantPicker.parentElement !== target) {
        target.appendChild(variantPicker);
      }
      
      const customizeContainer = document.querySelector('[id^="customization-container-"]');
      if (customizeContainer && customizeContainer.parentElement !== target) {
        target.appendChild(customizeContainer);
      }
    }
    // =======================================

    updatePaymentButtonVisibility() {
      const form = this.getForm();
      if (!form) return;
      // Esconde APENAS botões de "Comprar Agora" dinâmicos. Deixa o Add to Cart intacto.
      const payBtn = form.querySelector('.shopify-payment-button');
      if (payBtn) {
        payBtn.style.display = 'none';
      }
    }

    formatMoney(cents) {
      const val = cents / 100;
      const locale = document.documentElement.lang || 'en-US';
      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
        }).format(val);
      } catch (e) {
        return '$' + val.toFixed(2);
      }
    }

    getForm() {
      return document.querySelector(`form[id="${this.formId}"][action*="/cart/add"]`)
        || document.querySelector(`form[is="product-form"][action*="/cart/add"]`);
    }

    showFormError(msg) {
      const form = this.getForm();
      if (!form) { alert(msg); return; }
      const errEl = form.querySelector('.product-form__error-message');
      if (errEl) { errEl.hidden = false; errEl.textContent = msg; }
      else alert(msg);
    }

    clearFormError() {
      const form = this.getForm();
      if (!form) return;
      const errEl = form.querySelector('.product-form__error-message');
      if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
    }

    setupCarousels() {
      this._carouselResizeListener = this.updateAllCarouselsVisibility.bind(this);
      window.addEventListener('resize', this._carouselResizeListener);

      const carousels = this.querySelectorAll('.bundle-picker__carousel-wrapper');
      carousels.forEach(wrapper => {
        const carousel = wrapper.querySelector('.bundle-picker__grid--carousel');
        const prevBtn = wrapper.querySelector('.bundle-picker__carousel-btn--prev');
        const nextBtn = wrapper.querySelector('.bundle-picker__carousel-btn--next');

        if (!carousel || !prevBtn || !nextBtn) return;

        carousel.addEventListener('scroll', () => this.updateCarouselButtons(carousel, prevBtn, nextBtn));

        prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const scrollAmount = carousel.clientWidth * 0.7; 
          carousel.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        });

        nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const scrollAmount = carousel.clientWidth * 0.7;
          carousel.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        });
      });
    }

    updateAllCarouselsVisibility() {
      const carousels = this.querySelectorAll('.bundle-picker__carousel-wrapper:not([hidden])');
      carousels.forEach(wrapper => {
        const carousel = wrapper.querySelector('.bundle-picker__grid--carousel');
        const prevBtn = wrapper.querySelector('.bundle-picker__carousel-btn--prev');
        const nextBtn = wrapper.querySelector('.bundle-picker__carousel-btn--next');
        if (carousel && prevBtn && nextBtn) {
          this.updateCarouselButtons(carousel, prevBtn, nextBtn);
        }
      });
    }

    updateCarouselButtons(carousel, prevBtn, nextBtn) {
      if (carousel.scrollWidth <= carousel.clientWidth) {
        prevBtn.hidden = true;
        nextBtn.hidden = true;
        return;
      }
      prevBtn.hidden = carousel.scrollLeft <= 5; 
      nextBtn.hidden = Math.ceil(carousel.scrollLeft + carousel.clientWidth) >= (carousel.scrollWidth - 5);
    }

    disconnectedCallback() {
      if (this._carouselResizeListener) {
        window.removeEventListener('resize', this._carouselResizeListener);
      }
    }

    setupFormIntercept() {
      setTimeout(() => {
        const form = this.getForm();
        if (!form) return;

        if (form._bundleInterceptHandler) {
          form.removeEventListener('submit', form._bundleInterceptHandler, true);
        }

        const submitHandler = async (e) => {
            if (this._submitting) {
              e.preventDefault();
              e.stopImmediatePropagation();
              return;
            }

            if (!this.selectedSecondVariantId) {
              e.preventDefault();
              e.stopImmediatePropagation();
              this.showFormError(`Please choose your FREE product first.`);
              this.pickingItemSlot = 2;
              this.showWizardStep('first');
              return;
            }

            e.preventDefault();
            e.stopImmediatePropagation();
            this.clearFormError();
            this._submitting = true;

            const primaryVariantId = form.querySelector('[name="id"]')?.value;
            if (!primaryVariantId) { this._submitting = false; return; }

            form.querySelectorAll('input[type="hidden"][name^="properties["]').forEach((el) => {
              if (/^properties\[(Nome|Número)\]$/.test(el.name)) el.remove();
            });
            const primaryProps = {};
            try {
              const fd = new FormData(form);
              for (const [key, value] of fd.entries()) {
                const match = key.match(/^properties\[([^\]]+)\]$/);
                const v = String(value || '').trim();
                if (match && v) primaryProps[match[1]] = v;
              }
            } catch (e) {}

            const submitBtns = form.querySelectorAll('[type="submit"]');
            submitBtns.forEach((btn) => {
              btn.setAttribute('aria-busy', 'true');
              btn.classList.add('loading');
            });

            try {
              let sectionsToBundle = [];
              document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', {
                bubbles: true,
                detail: { sections: sectionsToBundle },
              }));

              const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
              const qty = parseInt(form.querySelector('[name="quantity"]')?.value) || 1;
              const items = [
                { id: parseInt(primaryVariantId), quantity: qty },
                { id: parseInt(this.selectedSecondVariantId), quantity: qty },
              ];
              if (Object.keys(primaryProps).length) items[0].properties = primaryProps;
              if (this.selectedSecondProperties) items[1].properties = this.selectedSecondProperties;

              const addBody = { items };
              if (sectionsToBundle.length) addBody.sections = sectionsToBundle.join(',');

              const response = await fetch(`${root}cart/add.js`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest',
                  Accept: 'application/javascript',
                },
                body: JSON.stringify(addBody),
              });

              const addRawText = await response.text();
              let responseJson;
              try {
                responseJson = JSON.parse(addRawText);
              } catch (parseErr) {
                this.showFormError('Cart service returned an unexpected response. Please refresh and try again.');
                return;
              }

              if (!response.ok) {
                this.showFormError(responseJson.description || responseJson.message || 'Error adding to cart.');
                return;
              }

              const cartResponse = await fetch(`${root}cart.js`);
              const cartRawText = await cartResponse.text();
              let cartJson;
              try {
                cartJson = JSON.parse(cartRawText);
              } catch (parseErr) {
                cartJson = { item_count: 0, sections: responseJson.sections || {} };
              }
              cartJson.sections = responseJson.sections || cartJson.sections || {};

              try {
                if (window.theme?.pubsub?.publish) {
                  window.theme.pubsub.publish(
                    window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate,
                    { cart: cartJson }
                  );
                }
              } catch (e) {}

              try {
                document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                  detail: { product: responseJson }
                }));
              } catch (e) {}

              try {
                const cartDrawer = document.querySelector('cart-drawer');
                if (cartDrawer && typeof cartDrawer.show === 'function') {
                  cartDrawer.show(submitBtns[0] || null);
                } else {
                  window.location.href = `${root}cart`;
                }
              } catch (e) {
                window.location.href = `${root}cart`;
              }
            } catch (err) {
              this.showFormError(err.message || 'Error adding to cart.');
            } finally {
              this._submitting = false;
              submitBtns.forEach((btn) => {
                btn.removeAttribute('aria-busy');
                btn.classList.remove('loading');
              });
            }
        };

        form._bundleInterceptHandler = submitHandler;
        form.addEventListener('submit', submitHandler, true);
      }, 100);
    }
  }

  window.customElements.define('bundle-offer', BundleOffer);
})();